import { Component, ElementRef, Input, OnDestroy, OnInit, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';

import { ApiError, AuthService, ConfigService, DataTablesService, MessageService, VisualizacaoStorageService } from '../../../../../core';
import { CurrencyFormatPipe } from '../../../../../shared';
import { ConfigEmpresa, createNomeCliente, createNomeRepresentante } from '../../../../configuracoes/app/empresa';
import { UsuarioPerfil } from '../../../../usuario/usuario-perfil';
import { TituloReceberFilter } from '../../../filter';
import { TituloReceberSearchOrderBy } from '../../../titulo-receber-search-orderby';
import { TituloReceberSearchClienteHttpService } from '../../services';
import { TituloReceberSearchCliente } from '../../titulo-receber-search-cliente';
import { TituloReceberSearchTotalCliente } from '../../titulo-receber-search-total-cliente';


@Component({
    selector: 'sgt-titulo-receber-cliente-table',
    templateUrl : './titulo-receber-cliente-table.component.html',
    styleUrls: ['./titulo-receber-cliente-table.component.less']
})
export class TituloReceberClienteTableComponent implements OnInit, OnDestroy {
    configEmpresa: ConfigEmpresa;
    perfilUsuario: UsuarioPerfil;
    idUsuario: number;

    @Input() visualizacaoStorageKey = 'tituloReceberClienteTableVisualizacao';
    @Input() filter: TituloReceberFilter;

    @Output() visualizarTitulos = new EventEmitter<TituloReceberSearchCliente>();

    // Total
    isLoadingTotal: boolean;
    total: TituloReceberSearchTotalCliente;

    dataTable: any;
    /** Subscriptions das pesquisas. Utilizado para realizar o unsubscribe e cancelar o retorno de requests de pesquissa pendentes antes de iniciar novos requests */
    private searchSubs$: Subscription;

    constructor(private el: ElementRef,
                private currencyFormatPipe: CurrencyFormatPipe,
                private authService: AuthService,
                private configService: ConfigService,
                private dataTablesService: DataTablesService,
                private messageService: MessageService,
                private visualizacaoStorageService: VisualizacaoStorageService,
                private tituloReceberSearchClienteHttpService: TituloReceberSearchClienteHttpService) { }

    ngOnInit(): void {
        this.configEmpresa = this.configService.getEmpresa();
        this.perfilUsuario = this.authService.getPerfilUsuario();
        this.idUsuario = this.authService.getIdUsuario();
    }

    search() {
        // Realizando unsubscribe dos subscriptions atuais e criando um novo para as próximas pesquisas
        this.searchSubs$?.unsubscribe();
        this.searchSubs$ = new Subscription();

        // Obtendo os totais dos títulos a receber
        this.getTotais()
            .then(() => {
                if (!this.dataTable) { // Table ainda não criada
                    // Obtendo os dados da datatable armazenados no storage para sabermos o order e posição do scroll
                    const vs = this.visualizacaoStorageService.get(this.visualizacaoStorageKey);

                    this.createTable(vs?.order)
                        .then(() => {
                            // Realizando scroll para a posição inicial salva
                            if (vs?.scrollerStartPosition > this.dataTable?.scroller?.page()?.end) {
                                this.dataTable?.scroller?.toPosition(vs?.scrollerStartPosition);
                            }
                        });
                } else { // Table já criada, somente damos um reload
                    this.dataTable.ajax.reload();
                }
            })
            .catch(() => {});
    }

    /** Obtem os totais dos títulos a receber */
    private getTotais(): Promise<TituloReceberSearchTotalCliente> {
        return new Promise<TituloReceberSearchTotalCliente>((resolve, reject) => {
            this.searchSubs$.add(this.tituloReceberSearchClienteHttpService.getTotais(this.filter)
                .subscribe(
                    total => {
                        this.total = total;
                        this.isLoadingTotal = false;
                        resolve(total);
                    },
                    (error: ApiError) => {
                        this.isLoadingTotal = false;
                        this.messageService.error(error.message, 'Erro ao obter os totais dos títulos a receber agrupados por clientes', error);
                        reject();
                    }
                )
            );

        })
    }

    /** Cria a dataTable dos títulos a receber */
    private createTable(initOrder: any[] = null): Promise<void> {
        return new Promise<void>((resolve) => {
            const columns: any[] = [
                {
                    data: null,
                    className: 'col-options',
                    orderable: false,
                    render: (data, type, row, meta) =>
                        // const entity = data as TituloReceberSearchCliente;

                         `
                            <span class="btn-group dropup table-options">
                                <button type="button" title="Opções" class="btn btn-link btn-options dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i class="fas fa-ellipsis-h" aria-hidden="true"></i>
                                </button>
                                <div class="dropdown-menu dropdown-menu-titulo-receber">
                                    <a class="dropdown-item" id="visualizar">
                                        <i class="fas fa-search"></i> Visualizar Títulos
                                    </a>
                                    </div>
                                </span>
                        `
                    ,
                    createdCell: (td, cellData, rowData, row, col) => {
                        const dropdown = jQuery(td).find('.btn-group');
                        // Ao abrir o dropdown, adicionamos ele no body para exibi-lo corretamente na table
                        dropdown.on('show.bs.dropdown', function() {
                            jQuery('body').append(dropdown.css({
                                    position: 'absolute',
                                    left: dropdown.offset().left,
                                    top: dropdown.offset().top
                                }).detach());
                        });
                        // Ai fechar o dropdown, adicionamos ele novamente a coluna das opções na table
                        dropdown.on('hidden.bs.dropdown', function() {
                            jQuery(td).append(dropdown.css({
                                position: 'relative',
                                left: 'auto',
                                top: 'auto'
                            }).detach());
                        });

                        // Vinculando os eventos de click das opções da tabela
                        const myself = this;
                        // Opções do dropdown
                        dropdown.on('click', 'a', function() {
                            if (this.id === 'visualizar') {
                                myself.visualizar(cellData);
                            }
                        });
                    }
                },
                {
                    data: null,
                    className: 'col-pessoa',
                    serverOrderByColumn: TituloReceberSearchOrderBy.Pessoa,
                    render: (data: TituloReceberSearchCliente, type, row, meta) => {
                        if (data) {
                            return `${data.codigoIntegracaoErpPessoa} - ${createNomeCliente(this.configEmpresa.identificacaoCliente, data.nomePessoa, data.nomeFantasiaPessoa)}`;
                        }
                        return '';
                    },
                    createdCell: (td, cellData: TituloReceberSearchCliente, rowData, row, col) => {
                        if (cellData) {
                            td.title = `${cellData.codigoIntegracaoErpPessoa} - ${createNomeCliente(this.configEmpresa.identificacaoCliente, cellData.nomePessoa, cellData.nomeFantasiaPessoa)}`;
                        }
                    }
                },
                {
                    data: null,
                    className: 'col-representante',
                    visible: !this.authService.isRepresentante(),
                    serverOrderByColumn: TituloReceberSearchOrderBy.Representante,
                    render: (data: TituloReceberSearchCliente, type, row, meta) => {
                        if (data && data.codigoIntegracaoErpRepresentante) {
                            return `${data.codigoIntegracaoErpRepresentante} - ${createNomeRepresentante(this.configEmpresa.identificacaoRepresentante, data.nomeRepresentante, data.nomeFantasiaRepresentante)}`;
                        }
                        return '';
                    },
                    createdCell: (td, cellData: TituloReceberSearchCliente, rowData, row, col) => {
                        if (cellData && cellData.codigoIntegracaoErpRepresentante) {
                            td.title = `${cellData.codigoIntegracaoErpRepresentante} - ${createNomeRepresentante(this.configEmpresa.identificacaoRepresentante, cellData.nomeRepresentante, cellData.nomeFantasiaRepresentante)}`;
                        }
                    }
                },
                {
                    data: 'valor',
                    className: 'col-valor text-right',
                    serverOrderByColumn: TituloReceberSearchOrderBy.SumValor,
                     render: (data) => this.currencyFormatPipe.transform(data, 1, 2, 2)
                },
                {
                    data: 'valorPago',
                    className: 'col-valor-pago text-right',
                    serverOrderByColumn: TituloReceberSearchOrderBy.SumValorPago,
                    render: (data) => this.currencyFormatPipe.transform(data, 1, 2, 2)
                },
                {
                    data: 'valorJuros',
                    className: 'col-valor-juros text-right',
                    serverOrderByColumn: TituloReceberSearchOrderBy.SumValorJuros,
                    render: (data) => this.currencyFormatPipe.transform(data, 1, 2, 2)
                },
                {
                    data: 'valorSaldo',
                    className: 'col-valor-saldo text-right',
                    serverOrderByColumn: TituloReceberSearchOrderBy.SumValorSaldo,
                    render: (data) => this.currencyFormatPipe.transform(data, 1, 2, 2)
                }
            ];

            const columnDefs: any[] = [
                {orderable: false, targets: [0]}
            ];

            this.dataTablesService.showTable('#tituloReceberTableCliente', this.dataTable, {
                columnDefs,
                columns,
                order: [[1, 'asc']],
                searching: false,
                info: false,
                serverSide: true,
                processing: true,
                deferRender: true,
                scroller: true,
                scrollX: true,
                // stateSave: true,
                ajax: (data, callback, settings) => {
                    // Order By
                    const order = data?.order[0];
                    const orderColumn = columns[order?.column];
                    const orderBy = orderColumn?.serverOrderByColumn;
                    const orderByDir = order?.dir;
                    // Limit
                    const limit = data.length;
                    // Offset
                    const offset = data.start;

                    this.searchSubs$.add(this.tituloReceberSearchClienteHttpService.search(this.filter, orderBy, orderByDir, limit, offset)
                        .subscribe(
                            entities => {
                                callback({recordsTotal: this.total?.quantidadeClientes, recordsFiltered: this.total?.quantidadeClientes, data: entities});
                            },
                            (error: ApiError) => {
                                this.messageService.error(error.message, 'Erro ao pesquisar os títulos a receber agrupados por clientes', error);
                                callback({recordsTotal: 0, recordsFiltered: 0, data: []});
                            }
                        )
                    );
                }
            }).then(dataTable => {
                this.dataTable = dataTable;

                setTimeout(() => {
                    // Adicionando evento handler no scroll do body da datatable
                    jQuery(this.el.nativeElement).find('.dataTables_scrollBody').on('scroll', () => {
                        this.visualizacaoStorageService.set(null, null, this.dataTable?.page?.info()?.page, this.dataTable?.order(), this.dataTable?.scroller?.page()?.start, this.visualizacaoStorageKey);
                    });

                    resolve();
                }, 500);
            })
            .catch(() => {});
        });
    }

    /** Atualizando a pesquisa */
    refresh() {
        // Atualizando a pesquisa através da datatable
        this.dataTable?.draw(false);
        // Atualizando os totais
        this.getTotais()
            .then(() => {})
            .catch(() => {});
    }

    /** Abre o modal para visualizar o título a recber */
    visualizar(entity: TituloReceberSearchCliente) {
        if (!entity) {
            return;
        }

        this.visualizarTitulos.emit(entity);
    }



    ngOnDestroy() {
        this.searchSubs$?.unsubscribe();
        // Removendo evento de scroll do body da datatable
        jQuery(this.el.nativeElement).find('.dataTables_scrollBody').off('scroll');
    }
}
